import {Injectable} from '@angular/core';
import { Router, RouterStateSnapshot } from '@angular/router';
import {SsrCookieService} from "ngx-cookie-service-ssr";

@Injectable()
export class CustomerGuard  {

  constructor(private router: Router,
              private cookieService: SsrCookieService) { }

  canActivate(state: RouterStateSnapshot) {
    if (!this.cookieService.get("role") || this.cookieService.get("role") == "CLIENT") {
      return true;
    }

    this.router.navigate(['/compte/informations']);
    return false;
  }
}
